/**
 * Application state object
 * @typedef {Object} AppState
 * @property {Array} quizzes - All available quizzes
 * @property {Object|null} currentQuiz - Currently active quiz
 * @property {number} currentQuestionIndex - current question index
 * @property {number} score - Number of correct answers
 * @property {string|null} selectedAnswer - Selected answer text
 * @property {boolean} isAnswerSubmitted - Whether answer has been submitted
 */
export const state = {
  quizzes: [],
  currentQuiz: null,
  currentQuestionIndex: 0,
  score: 0,
  selectedAnswer: null,
  isAnswerSubmitted: false,
};

/**
 * Reset the quiz state to initial values
 */
export const resetQuiz = () => {
  state.currentQuiz = null;
  state.currentQuestionIndex = 0;
  state.score = 0;
  state.selectedAnswer = null;
  state.isAnswerSubmitted = false;
};

/**
 * Set the selected answer
 * @param {string} answer - The answer text selected by user
 */
export const selectAnswer = (answer) => {
  state.selectedAnswer = answer;
};

/**
 * Submits the current answer and updates the score if correct
 * @returns {boolean} true is answer was correct, false otherwise
 */
export const submitAnswer = () => {
  state.isAnswerSubmitted = true;
  const currentQuestion =
    state.currentQuiz.questions[state.currentQuestionIndex];
  const isCorrect = state.selectedAnswer === currentQuestion.answer;

  if (isCorrect) {
    state.score++;
  }

  return isCorrect;
};

/**
 * Advances the next question and resets selection state
 */
export const nextQuestion = () => {
  state.currentQuestionIndex++;
  state.selectedAnswer = null;
  state.isAnswerSubmitted = false;
};

/**
 * Check if the quiz is complete
 * @returns {boolean} True if all questions have been answered
 */
export const isQuizComplete = () => {
  return state.currentQuestionIndex >= state.currentQuiz.questions.length;
};
